module.exports = __webpack_public_path__ + "ffc32fda94864d4d22555e07761c360d.jpg";